var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607887"
    },
    d: "M358.619,132.416h-205.24c-12.798,0-23.174-10.375-23.174-23.174V58.207 C130.206,26.112,156.318,0,188.413,0h135.172c32.095,0,58.207,26.112,58.207,58.207v51.035 C381.793,122.041,371.418,132.416,358.619,132.416z M176.553,86.069h158.893V58.207c0-6.54-5.32-11.86-11.86-11.86H188.413 c-6.54,0-11.86,5.32-11.86,11.86V86.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9BEC9"
    },
    d: "M254.963,86.069h-78.411V58.207c0-6.54,5.32-11.86,11.86-11.86h66.551V0h-66.551 c-32.095,0-58.207,26.112-58.207,58.207v51.035c0,12.798,10.375,23.174,23.174,23.174h101.585L254.963,86.069L254.963,86.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607887"
    },
    d: "M435.1,172.852c-3.144-3.608-7.695-5.679-12.479-5.679H89.377c-4.785,0-9.336,2.07-12.479,5.679 c-3.144,3.607-4.573,8.398-3.919,13.138l43.037,311.72c1.131,8.189,8.131,14.288,16.397,14.288h247.17 c8.266,0,15.267-6.099,16.397-14.288l43.037-311.72C439.672,181.25,438.243,176.459,435.1,172.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9BEC9"
    },
    d: "M254.963,167.174H89.377c-4.785,0-9.336,2.07-12.479,5.679c-3.144,3.607-4.573,8.398-3.919,13.138 l43.037,311.72c1.131,8.189,8.131,14.288,16.397,14.288h122.55V167.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43545E"
    },
    d: "M440.059,81.655H71.94c-24.001,0-43.526,19.525-43.526,43.526v31.57 c0,24.001,19.525,43.526,43.526,43.526h368.119c24.001,0,43.526-19.525,43.526-43.526v-31.57 C483.585,101.18,464.06,81.655,440.059,81.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607887"
    },
    d: "M255.148,437.284c-9.141,0-16.553-7.411-16.553-16.553V250.716c0-9.141,7.411-16.553,16.553-16.553 s16.553,7.411,16.553,16.553v170.015C271.7,429.873,264.289,437.284,255.148,437.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43545E"
    },
    d: "M255.148,437.284v-203.12c9.141,0,16.553,7.411,16.553,16.553v170.015 C271.7,429.873,264.289,437.284,255.148,437.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#607887"
    },
    d: "M193.466,437.285c-8.097,0-15.175-5.947-16.363-14.195L152.62,253.076 c-1.303-9.048,4.976-17.44,14.024-18.742c9.055-1.309,17.44,4.976,18.742,14.024l24.483,170.014 c1.303,9.048-4.976,17.44-14.024,18.742C195.045,437.23,194.251,437.285,193.466,437.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43545E"
    },
    d: "M318.533,437.285c-0.786,0-1.58-0.056-2.379-0.171c-9.049-1.303-15.328-9.694-14.024-18.742 l24.483-170.014c1.303-9.048,9.71-15.328,18.742-14.024c9.049,1.303,15.328,9.694,14.024,18.742L334.895,423.09 C333.708,431.339,326.629,437.285,318.533,437.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#526773"
    },
    d: "M254.963,81.655H71.94c-24.001,0-43.526,19.525-43.526,43.526v31.57 c0,24.001,19.525,43.526,43.526,43.526h183.023V81.655z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.404ae14293545edfb7a60acd9b434a24.svg";
export { ForwardRef as ReactComponent };